export const selectDeviceTreeUpdateTime = (state) => state.devices.tree_last_update_time;
